import { gsap } from "gsap";

export default function (callback) {
    let skipLoading = false,
        heroBackground = document.querySelector('[data-block="hero-bg"]')

    const checkLoadingState = (animAfter = '') => {
        if ((heroBackground ? heroBackground.complete : true) && document.readyState !== 'loading') {
            animAfter.length && introTimeline.seek(animAfter)
            skipLoading = true
        }
    }

    const addClassAfterLoading = () => {
        document.body.classList.add('is-loaded')
    }

    const introTimeline = gsap.timeline({ defaults: { duration: 1.6, ease: "cubic" } }),
        loadingTimeline = gsap.timeline({ repeat: 8, repeatDelay: .64, defaults: { duration: 1.6, ease: "cubic" }, onRepeat: checkLoadingState, onRepeatParams: ["skipLoading"] }),
        scrollIndicator = gsap.timeline({ repeat: -1, repeatDelay: .8 }),
        circle = document.querySelector('[data-block="intro"]').querySelector('circle'),
        circleLength = circle.getTotalLength()

    gsap.set('[data-block="circle"]', { strokeDashoffset: circleLength, strokeDasharray: circleLength })
    gsap.set('[data-block*="title-"], [data-block="header"] > *', { opacity: 0 })
    gsap.set('[data-block="logo"]', { left: '50%', xPercent: -50 })

    loadingTimeline.fromTo('[data-block="symbol"]', { rotate: -405, transformOrigin: "50% 50%" }, { rotate: -45 })

    checkLoadingState()
    introTimeline.addLabel('startLoading')
        .fromTo(
            '[data-block="symbol"]',
            { opacity: 0, scale: .4, rotate: -405, transformOrigin: "50% 50%", duration: 1 },
            { opacity: 1, scale: 1, rotate: skipLoading ? 0 : -45, onComplete: checkLoadingState, onCompleteParams: [skipLoading ? "finishLoading" : "skipLoading"] }
        ).to('[data-block="logo"]', { opacity: 1 }, '<')
        .add(loadingTimeline, '+=.64')
        .addLabel("skipLoading", ">")
        .fromTo('[data-block="symbol"]', { rotate: -405, transformOrigin: "50% 50%" }, { rotate: 0 }, '+=.64')
        .addLabel("finishLoading", ">")
        .to('[data-block="circle"]', { strokeDashoffset: 0, duration: 2 }, "-=.24")
        .fromTo('[data-block="title-left"]', { yPercent: -50 }, { yPercent: 0, opacity: 1 }, "-=.8")
        .fromTo('[data-block="title-right"]', { yPercent: 50 }, { yPercent: 0, opacity: 1 }, "<")
        .to('[data-block="intro"]', { yPercent: -100, paddingTop: '40%', duration: 1.2 }, '+=.64')
        .to('[data-block="logo"]', { left: '24px', xPercent: 0, duration: 2 }, '<')
        .call(callback, [], '<')

    if (document.querySelector('[data-block="hero"]')) {
        scrollIndicator.fromTo('[data-block="hero-indicator"] span', { opacity: 0 }, { opacity: 1, duration: .24, stagger: .08 })
            .to('[data-block="hero-indicator"] span', { opacity: 0, duration: 2.4, stagger: .16 }, '<.24')

        introTimeline.from('[data-block="hero-bg"]', { opacity: 1, scale: 2, duration: 2 }, '<')
            .from('[data-block="hero-heading"] span', { opacity: 0, yPercent: 40, stagger: .04 }, '>')
            .from('[data-block="hero-content"]', { opacity: 0, yPercent: 24 }, '>')
            .to('[data-block="header"] > *', { opacity: 1 }, '<')
            .add(scrollIndicator, '>')
            .call(addClassAfterLoading, [], '<')
    } else {
        introTimeline.to('[data-block="header"] > *', { opacity: 1 }, '<')
            .call(addClassAfterLoading, [], '-=1.2')
    }

    return introTimeline
}